import { useFormContext, withForm } from '@oscar/form';
import { Col, Row, Button } from '@oscar/theme';
import { STATISTIC } from 'common/constants';
import { APIS } from 'common/constants/endpoints';
import { Roles, useAuth } from 'features/auth';
import React from 'react';

export type StatisticProps = {
  onClick?: (type: string) => void;
  currentRole?: string[];
};
interface DisplayStatistic {
  numDraft?: boolean;
  numInService?: boolean;
  numPendingValidation?: boolean;
  numPendingRemoval?: boolean;
  numPendingQaQc?: boolean;
  numBilling?: boolean;
  numPendingProposal?: boolean;
  numPendingReinstatement?: boolean;
  numPendingPainting?: boolean;
}

function StatisticChil(props: StatisticProps & { [name: string]: any }) {
  const { title, total, color_stop1, color_stop2, isDisplay, status, onClick } =
    props;

  if (!isDisplay) {
    return <></>;
  }

  return (
    <Button
      type="ghost"
      className="statistic-request"
      style={{
        backgroundImage: `linear-gradient(to bottom right, ${color_stop1}, ${color_stop2})`,
      }}
      onClick={() => {
        onClick?.(status);
      }}
    >
      <Row className="row-statistic">
        <span>
          <div className="col-total-statistic">{total}</div>
        </span>
        <span className="space-col"></span>
        <span className="space-text">
          <div className="col-title-statistic">{title}</div>
        </span>
      </Row>
    </Button>
  );
}

const Statistic: React.FC<StatisticProps> = ({ onClick }) => {
  const [formContext] = useFormContext();
  const [auth] = useAuth();
  const statistic = formContext.selectors?.getDataByKey('getStatistic') || {};

  const role = auth?.getUserRoles();
  let isDisplayStatistic: DisplayStatistic = {};
  if (role.includes('PAINTING') || role.includes('INSULATION')) {
    isDisplayStatistic.numPendingValidation = true;
    isDisplayStatistic.numPendingQaQc = true;
    isDisplayStatistic.numBilling = true;
    if (role.includes('INSULATION')) {
      isDisplayStatistic.numPendingRemoval = true;
    }
  } else if (role.includes('CONTRACTOR')) {
    isDisplayStatistic.numPendingRemoval = true;
    isDisplayStatistic.numPendingProposal = true;
    isDisplayStatistic.numPendingReinstatement = true;
    isDisplayStatistic.numPendingPainting = true;
  } else {
    isDisplayStatistic = {
      numDraft: role.includes('OSCAR'),
      numInService: role.includes('OSCAR'),
    };
  }

  const ds: DisplayStatistic[] = Object.assign([], isDisplayStatistic);

  return (
    <div className="statistic">
      {STATISTIC &&
        STATISTIC.map((item: any, key: any) => {
          return (
            <StatisticChil
              key={`${item.type}${key}`}
              status={item.STATUS}
              title={item.TITLE}
              total={statistic[item.TYPE]}
              color_stop1={item.COLOR_STOP1}
              color_stop2={item.COLOR_STOP2}
              isDisplay={ds[item.TYPE]}
              onClick={onClick}
            />
          );
        })}
    </div>
  );
};

export default withForm<StatisticProps>({
  name: 'statistic',
  preload: [
    {
      name: 'getStatistic',
      url: APIS.STATISTIC,
      method: 'POST',
      nextParams: data => {
        const roleId = Roles.indexOf(data?.currentRole?.[0]) + 1;
        return {
          currentRole: roleId,
        };
      },
    },
  ],
})(Statistic);
